import { Component, OnInit, Input, Output, EventEmitter, input } from '@angular/core';
import { GameViewFlatModel } from '../../models/GameModels';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { NgStyle, DatePipe } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { MatDivider } from '@angular/material/divider';


@Component({
    selector: 'app-game-card',
    templateUrl: './game-card.component.html',
    styleUrls: ['./game-card.component.css'],
    imports: [NgStyle, MatRipple, MatDivider, MatIconButton, DatePipe]
})
export class GameCardComponent implements OnInit {

  @Input() Game: GameViewFlatModel;
  readonly ShowDate = input<boolean>(undefined);
  readonly DateDisplay = input<string>("GameDate");

  
  @Output() openAddEvent = new EventEmitter();
  @Output() removeEvent = new EventEmitter();


  constructor(public _router: Router) { }

  ngOnInit() {

  }

  currentTimeZone(){
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  openGameDetails(GameId: string){
    this._router.navigate(['/scouting/gamedetails', GameId]);
    
  }

  addGameToSchedule(){
    console.log("TEst")
    this.openAddEvent.emit(this.Game.GameId);
  }

  removeGameFromSchedule(){
    console.log("Remove")
    this.removeEvent.emit(this.Game.EventId);
  }



}
